export const clearFromEmptyKeys = <T>(obj: T): T => {
  for (let prop in obj) {
    if (obj[prop] === null || obj[prop] === undefined || obj[prop] === '') {
      delete obj[prop];
    }
  }

  return obj;
};
